export enum TenantUserType {
  OWNER,
  ADMIN,
  MEMBER,
}
